import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-tabs', 'selectTag', 'Izvēlieties cilni');
Labels.set('ui-tabs', 'left', 'Ritiniet pa kreisi');
Labels.set('ui-tabs', 'right', 'Ritiniet pa labi');
